export enum PressureSensitivityEnum {
  FIRM_LYING_POSITION = 'firm_lying_position',
  SOFT_LYING_SURFACE = 'soft_lying_surface',
}
